var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
import { AngledContainer } from '../angledContainer/AngledContainer';
var angles = {
    topLeftInit: 0,
    topLeftEnd: 0,
    topRightInit: 100,
    topRightEnd: 0,
    bottomRightInit: 100,
    bottomRightEnd: 80,
    bottomLeftInit: 0,
    bottomLeftEnd: 100,
};
var BackgroundAngledColor = function (props) { return (_jsxs(_Fragment, { children: [_jsx(AngledContainer, __assign({ className: "long-hero-video-background absolute top-[35px] -left-[25px] h-full w-full md:top-[60px] md:-left-[85px] bg-enblue-900" }, angles), void 0),
        _jsx(AngledContainer, __assign({ className: "long-hero-video-background absolute top-0 left-0 flex h-full w-full items-center justify-center bg-enblue-500" }, angles), void 0), props.children] }, void 0)); };
export default BackgroundAngledColor;
